import { api } from './api';
const API_BASE_URL = '/popin/admin/monitoring';

export const adminApi = {
  /**
   * Get AI service metrics for admin dashboard
   * @param {number} limit - Maximum number of recent requests
   * @param {string} startDate - ISO format start date (e.g., '2025-10-06T00:00:00Z')
   * @param {string} endDate - ISO format end date (e.g., '2025-10-07T23:59:59Z')
   */
  async getAIMetrics(limit, startDate, endDate) {
    try {
      const params = new URLSearchParams();
      if (limit && Number(limit) > 0) {
        params.append('limit', Number(limit));
      }
      if (startDate) {
        params.append('start_date', startDate);
      }
      if (endDate) {
        params.append('end_date', endDate);
      }
      
      const url = params.toString() 
        ? `${API_BASE_URL}/ai-metrics?${params.toString()}`
        : `${API_BASE_URL}/ai-metrics`;
      
      console.log('adminApi: Calling', url);
      const response = await api.raw('GET', url);
      const json = await response.json();
      console.log('adminApi: AI metrics response (full JSON):', json);
      return json; // Return full JSON with success and data
    } catch (error) {
      console.error('adminApi: Failed to fetch AI metrics:', error);
      console.error('adminApi: Error details:', error.message, error.stack);
      return undefined; // Return undefined instead of throwing
    }
  },

  /**
   * Get AI service health status
   */
  async getAIHealth() {
    try {
      console.log('adminApi: Calling', `${API_BASE_URL}/ai-health`);
      const response = await api.raw('GET', `${API_BASE_URL}/ai-health`);
      const json = await response.json();
      console.log('adminApi: AI health response (full JSON):', json);
      return json; // Return full JSON with success and data
    } catch (error) {
      console.error('adminApi: Failed to fetch AI health:', error);
      console.error('adminApi: Error details:', error.message, error.stack);
      return undefined;
    }
  },

  /**
   * Get system overview
   */
  async getSystemOverview() {
    try {
      console.log('adminApi: Calling', `${API_BASE_URL}/system-overview`);
      const response = await api.raw('GET', `${API_BASE_URL}/system-overview`);
      const json = await response.json();
      console.log('adminApi: System overview response (full JSON):', json);
      return json; // Return full JSON with success and data
    } catch (error) {
      console.error('adminApi: Failed to fetch system overview:', error);
      console.error('adminApi: Error details:', error.message, error.stack);
      return undefined;
    }
  },

  /**
   * Get logs with search and pagination
   */
  async getLogs(params = {}) {
    try {
      const response = await api.get(`${API_BASE_URL}/logs`, { params });
      return response.data;
    } catch (error) {
      console.error('Failed to fetch logs:', error);
      throw error;
    }
  }
};

// Named exports for individual functions
export const getAIMetrics = adminApi.getAIMetrics;
export const getAIHealth = adminApi.getAIHealth;
export const getSystemOverview = adminApi.getSystemOverview;
export const getLogs = adminApi.getLogs;
